var React = require('react');

function X30Bleach80Water (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("path",{"className":"cls-1","d":"M1.58,52.48L31.47,1.77l29.9,50.71H1.58Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M61.07,28.97s-5.88-7.67-12.66-7.67c-6.78,0-10.17,7.67-16.94,7.67-6.78,0-10.17-7.67-16.94-7.67S1.87,28.97,1.87,28.97","key":1})])]);
}

X30Bleach80Water.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 62.95 53.38"};

module.exports = X30Bleach80Water;

X30Bleach80Water.default = X30Bleach80Water;
